/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiBaseUrl: 'https://dev-api.brokerdiscoverycall.com/api/',
  stripePublishKey: 'pk_test_51NQbNHESNq06v4lkL4XSvejtSZfA5HlOUE2MhfU48JeoPyhWhzV7PqaWNoyMFNF5MpH5ZvVQmt1UH77BiEOiyXG300eeB4yW1t',
  stripePriceId: 'prctbl_1P1y8sESNq06v4lkBm5lHADH',
  pusher_key: '2c1bbd2fa2f0386904d9'
};